import {
	createRootRouteWithContext,
	HeadContent,
	Scripts
} from '@tanstack/react-router'
import type { ReactNode } from 'react'
import type { RouterContext } from '@/router'
import '@/index.css'
import '@/lib/i18n'

export const Route = createRootRouteWithContext<RouterContext>()({
	ssr: true,
	beforeLoad: ({ context, serverContext }) => ({
		appLanguage: serverContext?.appLanguage ?? context.appLanguage
	}),
	head: () => ({
		meta: [
			{ charSet: 'utf-8' },
			{
				name: 'viewport',
				content: 'width=device-width, initial-scale=1.0'
			},
			{
				name: 'description',
				content:
					'API REST per il One Piece Card Game: carte, set, immagini e regole per app e bot.'
			}
		],
		links: [{ rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' }],
		title: 'SeaLedger API'
	}),
	shellComponent: RootDocument
})

function RootDocument({ children }: { children: ReactNode }) {
	const { appLanguage } = Route.useRouteContext()

	return (
		<html lang={appLanguage}>
			<head>
				<HeadContent />
			</head>
			<body>
				{children}
				<Scripts />
			</body>
		</html>
	)
}
